import { Col, Typography, Layout, Row, List, Input, Button, Image } from "antd";
import {
  BiLogoLinkedin,
  BiLogoTwitter,
  BiLogoYoutube,
  BiLogoInstagram,
} from "react-icons/bi";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";

const { Footer } = Layout;
const { TextArea } = Input;

const ClientFooter = () => {
  const navigate = useNavigate();
  return (
    <Footer className="footer" style={{ height: "auto", padding: "0" }}>
      <Row
        style={{
          justifyContent: "center",
          padding: "0 10px",
        }}
      >
        <Col xs={24} md={20}>
          <Row style={{ justifyContent: "center" }}>
            <Col
              xs={24}
              md={10}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <Row>
                <Col xs={24} md={18}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    height={65}
                    // src="/images/logo-header 1.png"
                    src={ImageUrl("logo-footer.png")}
                    style={{ maxWidth: "100%" }}
                    onClick={() => navigate("/")}
                  />
                  <div style={{ padding: "10px 30px 0px 10px" }}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{ color: "#333d47", fontSize: 30 }}
                    >
                      About
                    </Typography.Title>
                    <Typography.Text
                      className="fontFamily1"
                      style={{ color: "#333d47", fontSize: 16 }}
                    >
                      We're a passionate group of educators working together to
                      create the best online learning experiences for adult
                      learners like you.
                    </Typography.Text>
                    <br />
                    <br />

                    <Row>
                      <Col xs={6} lg={3}>
                        <BiLogoLinkedin
                          style={{
                            color: "#333d47",
                            fontSize: 25,
                            cursor: "pointer",
                          }}
                        />
                      </Col>
                      <Col xs={6} lg={3}>
                        <BiLogoTwitter
                          style={{
                            color: "#333d47",
                            fontSize: 25,
                            cursor: "pointer",
                          }}
                        />
                      </Col>
                      <Col xs={6} lg={3}>
                        <BiLogoYoutube
                          style={{
                            color: "#333d47",
                            fontSize: 25,
                            cursor: "pointer",
                          }}
                        />
                      </Col>
                      <Col xs={6} lg={3}>
                        <BiLogoInstagram
                          style={{
                            color: "#333d47",
                            fontSize: 25,
                            cursor: "pointer",
                          }}
                        />
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Button
                        style={{
                          marginTop: "10px",
                          padding: "0px 30px",
                          cursor: "pointer",
                          background: "#00a79d",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "50px",
                        }}
                        onClick={() => navigate("/signup")}
                        size="large"
                      >
                        Register Now
                      </Button>
                      &emsp;
                      {/* <Button
                        style={{
                          marginTop: "10px",
                          padding: "0px 30px",
                          background: "#00a79d",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "50px",
                          cursor: "pointer",
                        }}
                        size="large"
                      >
                        Apply Now
                      </Button> */}
                    </Row>
                 
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              xs={24}
              md={6}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <div style={{ padding: "10px 30px 0px 10px" }}>
                <Typography.Title
                  className="fontFamily1"
                  style={{ color: "#333d47", fontSize: 30 }}
                >
                  Services
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    color: "#333d47",
                    fontSize: 18,
                    textDecoration: "underline",
                  }}
                >
                  {/* Training */}

                  <Link
                    to={"/tutor"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#333d47",
                      fontSize: 18,
                      textDecoration: "underline",
                    }}
                  >
                    Trainers
                  </Link>
                </Typography.Text>
                <List
                  className="footer-list"
                  size="small"
                  style={{ fontSize: 18 }}
                >
                  <List.Item key="elementary_tutoring" className="footerLink">
                    Head Start
                  </List.Item>
                  <List.Item
                    key="middle_school_tutoring"
                    className="footerLink"
                  >
                    Early Head Start
                  </List.Item>
                  <List.Item key="high_school_tutoring" className="footerLink">
                    Day Care
                  </List.Item>
                  <List.Item key="adult_tutoring" className="footerLink">
                    Family Child Care
                  </List.Item>
                </List>
                <br />

                <Typography.Text
                  className="fontFamily1"
                  style={{
                    color: "#333d47",
                    fontSize: 18,
                    textDecoration: "underline",
                  }}
                >
                  <Link
                    to={"https://www.wrightco.com"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#333d47",
                      fontSize: 18,
                      textDecoration: "underline",
                    }}
                  >
                    Consulting
                  </Link>
                </Typography.Text>
                <List
                  className="footer-list"
                  size="small"
                  style={{ fontSize: 18 }}
                >
                  <List.Item
                    key="academic_coaching"
                    className="footerLink"
                  >
                    <Link to="/termsandconditions" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Terms & Conditions
                    </Link>
                  </List.Item>
                  <List.Item
                    key="career_coaching"
                    className="footerLink"
                  >
                    <Link to="/privacyPolicy" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Privacy Policy
                    </Link>
                  </List.Item>
                  <List.Item
                    key="mindset_coaching"
                    className="footerLink"
                  >
                    <Link to="/termsOfService" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Terms Of Service
                    </Link>
                  </List.Item>
                  <List.Item
                    key="conflict_coaching"
                    className="footerLink"
                  >
                    <Link to="/refundPolicy" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Refund Policy
                    </Link>
                  </List.Item>
                  {/* <List.Item
                    key="goal_achievement_coaching"
                    className="footerLink"
                  >
                    Goal Achievement Consulting
                  </List.Item>
                  <List.Item key="focus_coaching" className="footerLink">
                    Focus Consulting
                  </List.Item> */}
                </List>
              </div>
            </Col>
            <Col
              xs={24}
              md={6}
              style={{ padding: "30px 0", fontFamily: "Lato" }}
              className={"footer-column"}
            >
              <div style={{ padding: "10px 30px 0px 10px" }}>
                <Typography.Title
                  className="fontFamily1"
                  style={{ color: "#333d47", fontSize: 30 }}
                >
                  Navigation
                </Typography.Title>
                <List
                  className="footer-list"
                  size="small"
                  style={{ fontSize: 18 }}
                >
                  <List.Item
                    key="home"
                    className="footerLink"
                  >
                    <Link to="/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Home
                    </Link>
                  </List.Item>
                  <List.Item
                    key="about"
                    className="footerLink"
                  >
                    <Link to="/about-us" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      About
                    </Link>
                  </List.Item>
                  <List.Item
                    key="services"
                    className="footerLink"
                  >
                    <Link to="/services" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Services
                    </Link>
                  </List.Item>
                  <List.Item
                    key="book_online"
                    className="footerLink"
                  >
                    <Link to="/pricingPlans" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Book Online
                    </Link>
                  </List.Item>
                  <List.Item
                    key="contact_us"
                    className="footerLink"
                  >
                    <Link to="/contact-us" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Contact Us
                    </Link>
                  </List.Item>
                  <List.Item
                    key="disclaimer"
                    className="footerLink"
                  >
                    <Link to="/disclaimer" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Disclaimer
                    </Link>
                  </List.Item>
                  <List.Item
                    key="copyright"
                    className="footerLink"
                  >
                    <Link to="/copyright" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                      Copyright
                    </Link>
                  </List.Item>
                </List>
                <br />

                <Typography.Title
                  className="fontFamily1"
                  style={{ color: "#333d47", fontSize: 30 }}
                >
                  Get In Touch
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    color: "#333d47",
                    fontSize: 18,
                    textDecoration: "underline",
                  }}
                >
                  {/* Training */}
                </Typography.Text>
                <List
                  className="footer-list"
                  size="small"
                  style={{ fontSize: 18 }}
                >
                  <List.Item
                    key="elementary_tutoring"
                    className="footerLink"
                    style={{ justifyContent: "start", gap: "10px" }}
                  >
                    <FaLocationDot />
                    <Link to="" target="_blank" rel="noopener noreferrer">
                      1000 Front St #147, Uniondale,NY 11553, USA
                    </Link>
                  </List.Item>
                  <List.Item
                    key="elementary_tutoring"
                    className="footerLink"
                    style={{ justifyContent: "start", gap: "10px" }}
                  >
                    <MdEmail />
                    <Link to={"https://support@wrightcoacademy.com"} target="_blank" rel="noopener noreferrer">
                      support@wrightcoacademy.com
                    </Link>
                  </List.Item>
                  <List.Item
                    key="elementary_tutoring"
                    className="footerLink"
                    style={{ justifyContent: "start", gap: "10px" }}
                  >
                    <FaPhoneAlt />
                    <a href="tel:+8777012899" className="footerLink">
                      +877-701-2899
                    </a>
                  </List.Item>
                </List>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        style={{
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
        }}
      >
        <Col xs={24} md={18}>
          <Row>
            <Col xs={24} md={14}>
              <p className="footerLink">
                All Rights Reserved WrightCo Academy&trade;.
                <a
                  style={{ color: "#333d47", textDecoration: "underline" }}
                ></a>
              </p>
            </Col>
            <Col xs={24} md={10}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  placeContent: "center",
                }}
              >
                <Link
                  to="/termsandconditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footerLink"
                  style={{ color: 'inherit' }}
                >
                  Terms & Conditions
                </Link>
                &emsp;
                <Link
                  to="/privacyPolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footerLink"
                  style={{ color: 'inherit' }}
                >
                  Privacy Policy
                </Link>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Footer>
  );
};

export default ClientFooter;
